import { getPortalToken, setPortalToken } from '../app/businessContext';

const E_PORTAL_BASE_URL = (process.env.REACT_APP_E_PORTAL_URL || '').replace(/\/$/, '');
const E_PORTAL_API_BASE_URL = (
  process.env.REACT_APP_E_PORTAL_API_URL ||
  `${E_PORTAL_BASE_URL}/api`
).replace(/\/$/, '');

export function resolvePortalAssetUrl(value) {
  if (!value || /^data:/i.test(value) || /^https?:\/\//i.test(value)) {
    return value || '';
  }

  return `${E_PORTAL_BASE_URL}${value.startsWith('/') ? value : `/${value}`}`;
}

export async function fetchPortalUser() {
  const response = await requestPortalAuthApi('/auth/me', {
    method: 'GET',
  });

  return normalizePortalAuthUser(response.user);
}

export async function updatePortalProfile(profilePayload) {
  const response = await requestPortalAuthApi('/auth/profile', {
    method: 'PATCH',
    body: profilePayload,
  });

  if (response.token) {
    setPortalToken(response.token);
  }

  return {
    ...response,
    user: normalizePortalAuthUser(response.user),
  };
}

export async function changePortalPassword(passwordPayload) {
  const response = await requestPortalAuthApi('/auth/change-password', {
    method: 'POST',
    body: JSON.stringify(passwordPayload),
  });

  if (response.token) {
    setPortalToken(response.token);
  }

  return {
    ...response,
    user: normalizePortalAuthUser(response.user),
  };
}

function normalizePortalAuthUser(user) {
  if (!user || typeof user !== 'object') {
    return user;
  }

  return {
    ...user,
    mustChangePassword: Boolean(user.mustChangePassword ?? user.must_change_password),
  };
}

async function requestPortalAuthApi(path, options = {}) {
  const portalToken = getPortalToken();
  const isFormData = typeof FormData !== 'undefined' && options.body instanceof FormData;
  const headers = {
    ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
    ...(portalToken ? { Authorization: `Bearer ${portalToken}` } : {}),
    ...(options.headers || {}),
  };

  let response;

  try {
    response = await fetch(`${E_PORTAL_API_BASE_URL}${path}`, {
      ...options,
      headers,
    });
  } catch (error) {
    throw new Error('Unable to reach e-Portal right now.');
  }

  const payload = await safeReadJson(response);

  if (!response.ok) {
    throw new Error(payload?.message || 'Unable to complete the request.');
  }

  return payload;
}

async function safeReadJson(response) {
  try {
    return await response.json();
  } catch (error) {
    return null;
  }
}
